import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const formatCurrency = (value: number, options = {}) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    ...options
  }).format(value);
};

export const formatPercent = (value: number) => {
  return new Intl.NumberFormat('en-US', {
    style: 'percent',
    minimumFractionDigits: 1
  }).format(value);
};

export const formatDate = (date: Date | string, options = {}) => {
  return new Intl.DateTimeFormat('en-US', options).format(new Date(date));
};

export const getMonths = (t: any) => ({
  0: t("months.january"),
  1: t("months.february"),
  2: t("months.march"),
  3: t("months.april"),
  4: t("months.may"),
  5: t("months.june"),
  6: t("months.july"),
  7: t("months.august"),
  8: t("months.september"),
  9: t("months.october"),
  10: t("months.november"),
  11: t("months.december")
});

export const getErrorMessage = (error: unknown): string => {
  if (error instanceof Error) {
    return error.message;
  }
  if (typeof error === 'string') {
    return error;
  }
  return 'An unexpected error occurred';
};